// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__wrlqa","footer":"Form_footer__ddUIu"};